<template>
  <Modal v-model="commodityPriceModal" :title="commodityPriceTitle" width="800" class-name="commonModalStyles"
    :transfer="false" @on-visible-change="commodityPriceChange">
    <Table
      highlight-row
      border
      max-height="500"
      :loading="tableLoading"
      :columns="tableColumns"
      :data="tableData"
      :span-method="handleSpan">
    </Table>
    <template #footer>
      <Button type="primary" @click="commodityPriceModal = false">{{ $t('key1000248') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {amountHandel, getSpanMethod, batchAllWarehouseData} from "@/utils/common";

export default {
  name: 'commodityPriceModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      commodityPriceModal: false,
      commodityPriceTitle: '',
      tableColumns: [],
      tableData: [],
    }
  },
  computed: {},
  created() {

  },
  methods: {
    // 初始化数据
    initCommodityPriceData(type, row, obj) {
      let v = this;
      let query = {};
      let tableColumns = [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'left',
          minWidth: 350,
          render(h, params) {
            let skuImgPath = params.row._productInfo.primaryImage;
            let spuImgPath = params.row._productInfo._spuInfo.primaryImage;
            let imgPath = skuImgPath ? skuImgPath : spuImgPath;
            let sku = params.row._productInfo.sku;
            let productGoodsSpecifications = params.row._productInfo.productGoodsSpecifications || [];
            ;
            let spec = productGoodsSpecifications.map(i => i.name + '：' + i.value).join('、');
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, null, imgPath),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row._productInfo._spuInfo.name),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, sku),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                  h('p', {
                    style: {
                      flex: 1
                    },
                    class: 'color-green'
                  }, spec),
                ]),
              ])
            ]);
          }
        },
      ];
      switch (type) {
        // 供货价详情
        case 'supplyPrice':
          v.commodityPriceTitle = obj.countryName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001193');
          let title = obj.countryName + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000882') + `(${v.currencyState})`;
          tableColumns.push({
            title: title,
            key: 'supplyPrice',
            align: 'left',
            minWidth: 120,
            render(h, params) {
              let countryCode = params.row.countryCode;
              if (obj.twoCode === countryCode) {
                let price = params.row.supplyPrice || 0;
                return h('span', amountHandel(price))
              }
            }
          });
          v.tableColumns = tableColumns;
          query = {
            countryCode: obj.twoCode,
            productGoodsIds: [],
            productId: row.productId
          }
          v.axios.post(api.post_productInfo_queryGoodsPriceById, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            this.tableLoading = false;
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              let newData = data.filter((item) => item.countryCode === obj.twoCode);
              if (newData.length > 0) {
                let productGoodsIds = [];
                newData.map((item) => {
                  productGoodsIds.push(item.productGoodsId);
                });
                let list = v.uniqueFunc(productGoodsIds);
                if (list.length > 0) {
                  (async () => {
                    v.tableData = await v.getProductInfoByIds(list, newData,
                      false, false, false, api.post_productInfo_queryByProductGoodsIds, 'supplier');
                  })();
                }
              }
              v.commodityPriceModal = true;
            }
          });
          break;
        // 仓库直发价详情
        case 'productCost':
          v.commodityPriceTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001194');
          tableColumns.push({
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000241'),
              key: 'warehouseName',
              align: 'left',
              minWidth: 150,
              render(h, params) {
                let {warehouseName, ymsWarehouseName} = params.row;
                let name = warehouseName || ymsWarehouseName;
                return h('span', name)
              }
            },
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000582') + v.currencyState + "）",
              key: 'directShippingPrice',
              align: 'left',
              minWidth: 160,
              render(h, params) {
                let price = params.row.productCost || 0;
                let isDeliveryWarehouseTalg = params.row.isDeliveryWarehouseTalg;
                return h('span', isDeliveryWarehouseTalg ? amountHandel(price) : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000592'))
              }
            });
          v.tableColumns = tableColumns;
          query = {
            receiptBatchNo: null,
            warehouseLocationId: null,
            productGoodsIds: [],
            productId: row.productId
          }
          v.axios.post(api.post_productInfo_queryGoodsInventoryById, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            this.tableLoading = false;
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              if (data.length > 0) {
                let productGoodsIds = [];
                data.map((item) => {
                  productGoodsIds.push(item.productGoodsId);
                });
                let list = v.uniqueFunc(productGoodsIds);
                if (list.length > 0) {
                  (async () => {
                    let newList = await v.getProductInfoByIds(list, data,
                      false, false, false, api.post_productInfo_queryByProductGoodsIds, 'supplier');
                    v.handleTableData(newList);
                  })();
                }
              }
              v.commodityPriceModal = true;
            }
          });
          break;
      }
    },
    // 处理列表数据
    handleTableData(data) {
      if (!data?.length) {
        this.tableData = data || [];
        return;
      }
      const ymsWarehouseIds = data.map(item => item.warehouseId).filter(Boolean);
      if (!ymsWarehouseIds.length) {
        this.tableData = data;
        return;
      }
      batchAllWarehouseData(ymsWarehouseIds).then(list => {
        const warehouseMap = {};
        list.forEach(warehouse => {
          let ymsWarehouseDeliverySettings = warehouse.ymsWarehouseDeliverySettings || [];
          let isDeliveryWarehouseTalg = warehouse.isDeliveryWarehouse === 1 && ymsWarehouseDeliverySettings.length > 0;
          warehouse.isDeliveryWarehouseTalg = isDeliveryWarehouseTalg;
          warehouseMap[warehouse.ymsWarehouseId] = warehouse;
        });
        this.tableData = data.map(item => ({
          ...item,
          isDeliveryWarehouseTalg: warehouseMap[item.warehouseId].isDeliveryWarehouseTalg || false,
          warehouseName: warehouseMap[item.warehouseId].name || ''
        }));
      });
    },
    // 监听弹窗
    commodityPriceChange(value) {
      if (!value) {
        this.tableColumns = [];
        this.tableData = [];
      }
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let colKeys = ['skuInfo'];
      let idField = 'productGoodsId';
      return getSpanMethod(this.tableData, colKeys, idField, row, column, rowIndex, columnIndex)
    },
  },
  watch: {},
  components: {}
};
</script>

<style lang="less">

</style>
